<!--工作台应用--->
<template>
    <div class="applicationList flex-col">
        <div class="list-box flex-col" v-for="(item, index) in constants" :key="index">
            <span class="title">{{ item.funcName }}</span>
            <div class="list-section flex-row">
                <div class="card flex-col" v-for="(childItem, childIndex) in item.childFunc" :key="childIndex">
                    <div class="card-group flex-col justify-between">
                        <div class="card-image flex-col">
                            <img class="image-icon" referrerpolicy="no-referrer" :src="childItem.iconUrl" @click="toQuitInherit(childItem.url)" alt="" />
                        </div>
                        <span class="card-title" v-html="childItem.funcName"></span>
                    </div>
                </div>
            </div>
            <div v-if="constants.length != index + 1" class="interval flex-col"></div>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast } from 'vant'


    export default {
        data() {
            return {
                constants: [],
            };
        },
        mounted() {
            this.onLoad();
        },

        methods: {
            onLoad() {
                request({
                    url: `/function/funcTree`,
                    method: "get",
                })
                    .then((res) => {
                        this.constants = res.data;
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' });
                    }).finally(() => {

                    });
            },
            //跳转页
            toQuitInherit(url) {
                this.$router.push({ name: url, query: {}, });
            },

        },
    };
</script>

<style scoped>
    .applicationList {
        position: relative;
        width: 750px;
        height: 1629px;
        background-color: rgba(255, 255, 255, 1);
        overflow: hidden;
    }

    .list-box {
        width: 750px;
    }

    .title {
        width: 160px;
        height: 56px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(53, 67, 76, 1);
        font-size: 40px;
        white-space: nowrap;
        line-height: 56px;
        text-align: left;
        margin: 30px 0 0 30px;
        font-weight: 700;
    }

    .list-section {
        width: 292px;
        height: 136px;
        justify-content: space-between;
        margin: 50px 0 0 50px;
    }

    .card {
        width: 112px;
        height: 136px;
        margin-right: 68px;
    }

    .card-group {
        width: 112px;
        height: 136px;
    }

    .card-image {
        width: 100px;
        height: 80px;
        background-size: 132px 112px;
        margin-left: 6px;
    }

    .image-icon {
        width: 100px;
        height: 80px;
        background-size: 132px 112px;
    }

    .card-title {
        width: 112px;
        height: 40px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(53, 67, 76, 1);
        font-size: 28px;
        white-space: nowrap;
        line-height: 40px;
        text-align: center;
        margin-top: 16px;
    }

    .justify-between {
        display: flex;
        justify-content: space-between;
    }

    .interval {
        width: 750px;
        height: 20px;
        background-color: rgba(249, 250, 252, 1);
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0);
        margin-top: 50px;
    }
</style>
